var $9df6ccd8ba00758d$exports = {};
$9df6ccd8ba00758d$exports = {
  "collapse": "Sa\u017Emi",
  "expand": "Pro\u0161iri"
};
export { $9df6ccd8ba00758d$exports as default };